import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { renderBlock } from '../../BlockRenderer/renderBlock.js';
import { renderBlocksList } from '../../BlockRenderer/renderBlockList.js';
import { getBorderStyle } from '../../utils/getBorderStyle.js';
import { style } from '../../utils/style.js';
import { SwipeListControl } from '../SwipeListControl/SwipeListControl.js';
export const renderCarouselBlocks = ({ blocksToRender, ...rest }) => (_jsx(SwipeListControl, { visibleItemCount: 0, gap: 0, arrowsPadded: true, children: renderBlocksList(blocksToRender, {
        ...rest.options,
        parent: rest.block,
        renderProps: (block, options, i) => (_jsx("div", { className: style('relative min-w-80', getBorderStyle(true)), children: renderBlock(block, options) }, String(i))),
    }) }));
//# sourceMappingURL=renderCarouselBlocks.js.map